import React, { Component } from "react";
import { get } from "lodash";
import { formatNumberOnDashBoard, formatNumber } from "../../helper";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import CountUp from "react-countup";

export class Graph extends Component {
  state = {
    updateValues: 0
  };

  componentDidMount() {
    window && window.addEventListener("scroll", this.onScroll);
  }

  onScroll = () => {
    let currentOffset = (window && window.scrollY) || 0;
    if (
      currentOffset === 200 ||
      currentOffset === 250 ||
      (currentOffset > 550 && currentOffset < 650)
    ) {
      this.setState({
        updateValues: Math.random()
      });
    }
  };

  render() {
    const { className, isOverlayRequired, data, icon } = this.props;
    let { updateValues } = this.state;
    const dataArr = get(data, "data") || [];
    const currentData = dataArr.map(value => {
      return value.y;
    });

    return (
      <React.Fragment>
        <div
          className={
            className
              ? `new-dashboard-graph ${className}`
              : "new-dashboard-graph"
          }
        >
          <div className="summary-top-wrapper">
            <div className="summary-total">
              <b>
                {isOverlayRequired ? (
                  <CountUp
                    start={updateValues}
                    end={get(data, "titleValue", 0)}
                    delay={0}
                    formattingFn={n =>
                      formatNumberOnDashBoard(
                        Number(n.toFixed(1)),
                        true,
                        true,
                        "."
                      )
                    }
                    duration={2.75}
                  >
                    {({ countUpRef }) => (
                      <React.Fragment>
                        <OverlayTrigger
                          overlay={
                            <Tooltip className="my-tooltip-1 project-val-tooltip">
                              &#x20B9;{" "}
                              {get(data, "titleValue") &&
                                parseInt(get(data, "titleValue", 0))}{" "}
                              Cr.
                            </Tooltip>
                          }
                        >
                          <div>
                            <span ref={countUpRef} />
                          </div>
                        </OverlayTrigger>
                      </React.Fragment>
                    )}
                  </CountUp>
                ) : (
                  <CountUp
                    start={updateValues}
                    end={get(data, "titleValue", 0)}
                    delay={0}
                    useEasing={true}
                    formattingFn={n => formatNumber(Number(n.toFixed(1)))}
                    duration={2.75}
                  >
                    {({ countUpRef }) => (
                      <div>
                        <span ref={countUpRef} />
                      </div>
                    )}
                  </CountUp>
                )}
              </b>
            </div>
            <div className="summary-label">{get(data, "titleText", "NA")}</div>
            <img src={icon} alt="Icon" />
          </div>
          <div className="dividation-wrapper">
            <div className="dividation">
              <div className="dividation-total">
                <b>{get(data, "leftValue", "NA")}</b>
              </div>
              <div className="dividation-label">
                <span>{get(data, "leftText", "NA")}</span>
              </div>
            </div>
            <div className="dividation">
              <div className="dividation-total">
                <b>{get(data, "centerValue", "NA")}</b>
              </div>
              <div className="dividation-label">
                {get(data, "centerText", "NA")}
              </div>
            </div>
            {get(data, "rightValue", "NA") && (
              <div className="dividation">
                <div className="dividation-total">
                  <b>{get(data, "rightValue", "NA")}</b>
                </div>
                <div className="dividation-label">
                  {get(data, "rightText", "NA")}
                </div>
              </div>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Graph;
